import { FURNITURE_CATALOG, STARTER_FURNITURE, type FurnitureDef } from './furniture';

export interface ShopGroup {
  name: string;
  items: FurnitureDef[];
}

export function shopGroups(): ShopGroup[] {
  const locked = FURNITURE_CATALOG.filter((f) => !STARTER_FURNITURE.includes(f.id));
  return [
    {
      name: 'Living',
      items: locked.filter((f) => ['lamp', 'cushion', 'bookshelf'].includes(f.id)),
    },
    {
      name: 'Decor',
      items: locked.filter((f) => ['painting', 'crystalOrb', 'pottedPlant'].includes(f.id)),
    },
    {
      name: 'Garden',
      items: locked.filter((f) => ['mushroomStool', 'fountain'].includes(f.id)),
    },
  ];
}
